// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    daysFromRegistration: t.maybe(t.Number)
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        daysFromRegistration: 90
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/state/criteria.js